<template>
  <QPageContainer>
    <QPage class="onboarding-carousel-page">
      <QCarousel
        ref="carousel"
        v-model="currentSlide"
        :fullscreen="$q.screen.lt.sm"
        transition-prev="slide-right"
        transition-next="slide-left"
        swipeable
        animated
        navigation
        class="onboarding-carousel bg-secondary"
      >
        <QCarouselSlide v-for="slide in slides" :key="slide.name" :name="slide.name">
          <OnboardingAssistant :slide="slide" :size-text="sizeText(slide)" />
        </QCarouselSlide>

        <template #control>
          <QCarouselControl position="top-right" :offset="[5, 30]">
            <QBtn color="white" :label="$t('CORE.BUTTONS.@IGNORE')" no-caps flat @click="handleIgnore()" />
          </QCarouselControl>

          <QCarouselControl position="bottom" :offset="[18, 75]">
            <div class="onboarding-btn">
              <template v-if="!isLastSlide()">
                <QBtn
                  size="22px"
                  class="full-width"
                  color="white"
                  text-color="secondary"
                  :label="$t('CORE.BUTTONS.@NEXT')"
                  no-caps
                  @click="$refs.carousel.next()"
                />
              </template>
              <template v-if="isLastSlide()">
                <QBtn
                  size="22px"
                  class="full-width"
                  color="white"
                  text-color="secondary"
                  :label="$t('CORE.BUTTONS.@START')"
                  no-caps
                  @click="handleFinished()"
                />
              </template>
            </div>
          </QCarouselControl>
        </template>
      </QCarousel>
    </QPage>
  </QPageContainer>
</template>

<script>
  import { StatusBar } from "@core/plugins/mobile";
  import { AuthenticationManager } from "@core/managers/authentication.manager";
  import { TrackingManager } from "@core/managers/tracking.manager";
  import { OnboardingService } from "@core/services";
  import OnboardingAssistant from "@etab/components/onboarding/Assistant.component.vue";
  import { FIREBASE_EVENTS } from "@core/constants";

  import { ETAB_ROUTES } from "@etab/config";

  export default {
    components: {
      OnboardingAssistant,
    },
    data() {
      return {
        currentSlide: undefined,
        slides: [],
      };
    },
    async created() {
      this.slides = await OnboardingService.getAssistantSlides();
      this.currentSlide = this.slides[0].name;
    },
    mounted() {
      StatusBar.setSecondaryBackground();
    },
    beforeUnmount() {
      StatusBar.setDefault();
    },
    methods: {
      isLastSlide() {
        const currentSlideIndex = this.slides.findIndex((slide) => slide.name === this.currentSlide);

        return currentSlideIndex === this.slides.length - 1;
      },
      sizeText(slide) {
        return slide.img ? "medium" : "large";
      },
      handleIgnore() {
        TrackingManager.addEvent({
          event: "funnel_onboarding_ignore",
        });
        TrackingManager.addEvent({
          event: FIREBASE_EVENTS.FUNNEL,
          step: "step2_onboarding",
        });
        this.exit();
      },
      handleFinished() {
        TrackingManager.addEvent({
          event: "funnel_onboarding_finished",
        });
        TrackingManager.addEvent({
          event: FIREBASE_EVENTS.FUNNEL,
          step: "step2_onboarding",
        });
        this.exit();
      },
      async exit() {
        const isAuthenticated = await AuthenticationManager.isUserAuthenticated();
        if (isAuthenticated) {
          this.$router.replace({ name: ETAB_ROUTES.userMenu.main.name });
        } else {
          this.$router.replace({ name: ETAB_ROUTES.signup.root.name });
        }
      },
    },
  };
</script>

<style lang="scss">
  @media screen and (min-width: $breakpoint-sm-min) {
    .onboarding-carousel-page {
      display: flex;
      .onboarding-carousel {
        flex: 1;
        max-width: inherit;
        height: inherit;
      }
    }
  }
  .onboarding-btn {
    margin: 0 auto;
    width: 100%;
    max-width: $page-max-width;
  }
</style>
